<template>
  <div>
    <object-model-relationship-data
      :handler="handler"
      :q="q"
      :object-model="handler.objectModel"
      :level="1"
      :path="path"
      :parent-tree-context="computedChildTreeContext"
      @select="select"
      start-opened
    />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue';
import {ReferencePathNode} from "~/models/referencePaths/referencePathNode";
import {ReferenceNodeType} from "~/enums/referenceNodeType";
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin';
import {IDynamicTreeContext} from '~/interfaces/dynamicFieldsInterfaces';
import DynamicElementMixin from '~/components/dynamicFieldsTrees/handlerComponents/common/dynamic-element-mixin.vue';
import ObjectModelAccountRelationDynamicFieldsHandler from '~/models/dynamicFields/handlers/objectModelAccountRelationDynamicFieldsHandler'
import ObjectModelAccountRelationData from '~/components/dynamicFieldsTrees/handlerComponents/object-model-account-relation-data.vue';

export default Vue.extend({
  mixins: [handlerComponentsMixin, handlerTreeContextMixin, DynamicElementMixin],
  components: {
    CollapsibleSection,
    ObjectModelAccountRelationData
  },
  props: {
    handler: {
      type: Object as () => ObjectModelAccountRelationDynamicFieldsHandler,
      required: true,
    },
  },
  computed: {
    path(): Array<ReferencePathNode> {
      return [
        new ReferencePathNode(null, {reference_type: ReferenceNodeType.ObjectModel, reference_id: this.handler.objectModel.id})
      ];
    },
    treeContext(): Partial<IDynamicTreeContext> {
      return {
        isTopLevelCollectionAssigned: false
        // do not send in parent here
      }
    }
  },
});
</script>